import createReducer from './createReducer';
import {
  FETCH_SOLUNAR,
  FETCH_SOLUNAR_SUCCESS,
  FETCH_SOLUNAR_FAILURE,
} from '../actions/solunar';

const initialState = {
  loading: false,
  solunar: {},
};

const handlers = {};

handlers[FETCH_SOLUNAR] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_SOLUNAR_SUCCESS] = (state, { solunar }) => ({
  ...state,
  loading: false,
  solunar,
});

handlers[FETCH_SOLUNAR_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/solunar.js